<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title">{{label}}</div>
    </div>
    <div class="card-content">
      <StatusReplicationView :connection="database"/>
    </div>
  </div>
</template>

<script>
  import StatusReplicationView from './StatusReplicationView'

  export default {
    name: 'CardStatus',
    components: {
      StatusReplicationView
    },
    props: {
      database: {
        required: true
      },
      label: {
        required: true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/StatusReplications/CardStatusReplication.vue